import Vue from 'vue';
import App from './App.vue';
import router from './router/index.js';
import VueWechatSdk from 'vue-wechat-sdk';

import VConsole from 'vconsole';
if (process.env.NODE_ENV !== 'production') {
  new VConsole();
}

Vue.use(VueWechatSdk);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
